import type { Fixture } from '@h2h/shared';
import { ChevronRight } from '../../../components/ui/icons';
import { cn } from '../../../lib/cn';
import { shortRider } from '../../../lib/cyclingRound';
import { shortDay, timeLabel } from '../helpers';

/** Read-only duel row inside the grouped stage list. */
export function StageResultRow({
  fixture,
  onOpen,
  last = false
}: {
  fixture: Fixture;
  onOpen: () => void;
  last?: boolean;
}) {
  const aName = fixture.riderA?.riderName ?? fixture.homeTeam;
  const bName = fixture.riderB?.riderName ?? fixture.awayTeam;
  const dr = fixture.duelResult;
  const voided = fixture.status === 'VOID' || dr?.outcome === 'void';
  const settled = fixture.status === 'SETTLED' && !!dr && dr.outcome !== 'void';
  const live = fixture.status === 'LIVE';
  const winner = dr?.winner ?? null;
  const aWon = settled && winner === 'A';
  const bWon = settled && winner === 'B';

  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        'tap flex w-full items-center gap-2.5 px-3 py-[11px] text-left active:bg-black/[0.03]',
        live && 'bg-[rgba(227,168,43,0.06)]',
        settled && 'bg-accent-wash/30',
        !last && 'border-b border-black/[0.06]'
      )}
    >
      <span
        className={cn(
          'grid h-[26px] w-[26px] shrink-0 place-items-center rounded-[8px] text-[10px] font-extrabold',
          settled ? 'bg-accent-wash text-accent-ink' : live ? 'bg-[rgba(227,168,43,0.18)] text-[#B5740A]' : 'bg-[#EFEFF3] text-ink3'
        )}
      >
        {voided ? '—' : settled ? '✓' : live ? '●' : '…'}
      </span>

      <div className="min-w-0 flex-1">
        <div className="truncate text-[13px] font-extrabold tracking-[-0.01em] text-ink">
          <span className={settled ? (aWon ? 'text-accent-ink' : 'text-ink3') : 'text-ink'}>{shortRider(aName)}</span>
          <span className="px-1 font-semibold text-ink4">v</span>
          <span className={settled ? (bWon ? 'text-accent-ink' : 'text-ink3') : 'text-ink'}>{shortRider(bName)}</span>
        </div>
        <div className="mt-0.5 truncate text-[10.5px] font-semibold text-ink3">
          {voided ? 'Void' : settled ? `${shortRider(aWon ? aName : bName)} won` : live ? 'In progress' : `${shortDay(fixture.kickoffAt)} · ${timeLabel(fixture.kickoffAt)}`}
        </div>
      </div>

      <ChevronRight width={14} height={14} strokeWidth={2.4} className="shrink-0 text-ink4" />
    </button>
  );
}
